const OUR_BUSINESSES_CONSTANTS = {
    GET_LIST_OUR_BUSINESSES: 'v1/page/our-businesses',
    GET_LIST_MEDICINES: 'v1/page/kpjtelemedicineservices2',
    GET_LIST_TENDER: 'v1/tenders',
    SEARCH_DATA: 'v1/search',
    GET_HERE_FOR_YOU: 'v1/page/hereforyou'
};

export default OUR_BUSINESSES_CONSTANTS;
